"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _usePagination = require("./Hooks/usePagination");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;
  const paginationRange = (0, _usePagination.usePagination)({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  }); // if (currentPage === 0 || paginationRange.length < 2) {
  //   return null;
  // }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)("pagination-container", {
      [className]: className
    })
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)("pagination-item", {
      disabled: currentPage === 1
    }),
    onClick: onPrevious
  }, "Prev"), paginationRange.map(pageNumber => {
    if (pageNumber === _usePagination.DOTS) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "pagination-item dots",
        key: Math.random()
      }, "\u2026");
    }

    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)("pagination-item", {
        selected: pageNumber === currentPage
      }),
      key: pageNumber,
      onClick: () => onPageChange(pageNumber)
    }, pageNumber);
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)("pagination-item", {
      disabled: currentPage === lastPage
    }),
    onClick: onNext
  }, "Next"));
};

exports.Pagination = Pagination;
Pagination.propTypes = {
  onPageChange: _propTypes.default.func,
  totalCount: _propTypes.default.number,
  siblingCount: _propTypes.default.number,
  currentPage: _propTypes.default.number,
  pageSize: _propTypes.default.number,
  className: _propTypes.default.string
};